import { useAffiliates } from '../../../hooks/affiliates/useAffiliates/useAffiliates';
import useTrackingParams from '../../../hooks/tracking/useTrackingParams/useTrackingParams';

export const Hooks: () => null = () => {
    useAffiliates();
    useTrackingParams();

    return null;
};
